import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  readonly label = input('');
  readonly severity = input<'success' | 'info' | 'warning' | 'primary' | 'help' | 'danger' | 'secondary'>('primary');

  get pSeverity(): 'success' | 'info' | 'warn' | 'primary' | 'help' | 'danger' | 'secondary' {
    const severity = this.severity();
    return severity === 'warning' ? 'warn' : severity;
  }
  readonly sizeClass = input<'p-button-sm' | 'p-button-md' | 'p-button-lg'>('p-button-sm');
  readonly iconStart = input('');
  readonly iconEnd = input('');
  readonly rounded = input(false);
  readonly textButton = input(false);
  readonly outlinedButton = input(false);
  readonly disabled = input(false);
  readonly isLoading = input(false);

  readonly iconOnlyButton = input(false);
  readonly icon = input<string>(); // used only with the icon only button

  readonly btnClick = output<MouseEvent>();
}
